import { Button, Container, Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import {
  getScoresCount,
  getUsersViaPagination,
} from "../../services/firestoreService";
import { DataGrid } from "@mui/x-data-grid";
import { convertToExcel } from "../../utills";
import "./UsersScores.css";

const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "firstName", headerName: "שם פרטי", width: 150 },
  { field: "lastName", headerName: "שם משפחה", width: 150 },
  {
    field: "email",
    headerName: "אימייל",
    width: 200,
  },
  {
    field: "phone",
    headerName: "טלפון",
    width: 200,
  },
  {
    field: "promotions",
    headerName: "אישור דיוור",
    renderCell: ({ value }) => <Checkbox checked={!!value} disabled />,
    width: 100,
  },
  {
    field: "score",
    headerName: "תוצאה",
    type: "number",
    width: 100,
  },
  {
    field: "createdAt",
    headerName: "תאריך",
    type: "string",
    width: 100,
  },
];

function UsersScores() {
  const navigate = useNavigate();
  const { logout } = UserAuth();
  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  const [pageState, setPageState] = useState({
    data: [],
    dataForIndex:[],
    total: 0,
    page: 1,
    pageSize: 10,
    lastDoc: null,
    firstDoc: null,
    getPrevPage: false,
  });
  const [isLoading, setIsLoading] = useState(true);

  const convertToFileExcel = () => {
    convertToExcel(columns);
  };

  useEffect(() => {

    const fetchData = async () => {
      setIsLoading(true);
      const response = await getUsersViaPagination(
        pageState.lastDoc,
        pageState.dataForIndex[pageState.page-2],
        pageState.pageSize,
        pageState.getPrevPage,
      );
      let totalScores = pageState.total;
      if (!totalScores) {
        totalScores = await getScoresCount();
      }
      setPageState({
        ...pageState,
        data: response.docs.map((userDoc) => {
          const user = userDoc.data();
          user.id = userDoc.id;
          return user;
        }),
        total: totalScores,
        lastDoc: response.docs[response.docs.length - 1],
        firstDoc: response.docs[0]
      });
      setIsLoading(false);
    };

    fetchData(pageState.lastDoc, pageState.firstDoc, pageState.pageSize);
  }, [pageState.page, pageState.pageSize]);

  return (
    <Container className="users-scores-container">
      <div className="buttons-container">
        <Button className="scores-btn" variant="contained" onClick={handleLogout}>
          התנתק
        </Button>
        <Button  className="scores-btn"variant="contained" onClick={convertToFileExcel}>
          הורד כקובץ אקסל
        </Button>
      </div>

      <DataGrid
        rows={pageState.data}
        rowCount={pageState.total}
        sx={{height:'unset'}}
        loading={isLoading}
        pageSizeOptions={[ 10, 25, 50, 100]}
        paginationModel={{
          page: pageState.page - 1,
          pageSize: pageState.pageSize,
        }}
        paginationMode="server"
        onPaginationModelChange={(newPageData) => {

          if (newPageData.page === 0) {
            setPageState((old) => ({
              ...old,
              lastDoc: null,
              page: 1,
              pageSize: newPageData.pageSize,
              getPrevPage: false,
              dataForIndex:[]
            }));
          } else if (newPageData.page < pageState.page) {

            setPageState((old) => ({
              ...old,
              page: newPageData.page + 1,
              pageSize: newPageData.pageSize,
              getPrevPage: true,
            }));
          } else {
            setPageState((old) => ({
              ...old,
              page: newPageData.page + 1,
              pageSize: newPageData.pageSize,
              getPrevPage: false,
              dataForIndex:[...old.dataForIndex, old.lastDoc]
            }));
          }
        }}
        columns={columns}
        disableColumnSelector
        disableColumnFilter
        disableColumnMenu
      />
    </Container>
  );
}

export default UsersScores;
